import * as Yup from 'yup'

export const cmsArticlesWidgetItemValidationSchema = Yup.array().of(
  Yup.object().shape({
    article: Yup.object().shape({
      id: Yup.number().required().label('Article'),
    }),
  })
)
